<template>
  <l-modal
    :title="t('reservations.custom-diners')"
    :button-text="t('ctas.save')"
    :secondary-button="true"
    :secondary-button-text="t('ctas.cancel')"
    @secondary-action="$emit('close')"
    @close="$emit('close')"
    @action="$emit('save', value)"
  >
    <div class="flex items-center gap-2 justify-center">
      <l-button icon="minus" size="medium" class="shrink-0" @click="value--" />
      <div class="w-16">
        <l-input v-model="value" size="medium" />
      </div>
      <l-button icon="plus" size="medium" class="shrink-0" @click="value++" />
    </div>
  </l-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { LButton, LInput, LModal } from '@last/core-ui/paprika'

const props = defineProps<{
  defaultValue: number
}>()

defineEmits<{
  close: []
  save: [number]
}>()

const { t } = useI18n()

watch(
  () => props.defaultValue,
  newValue => {
    value.value = newValue
  }
)

const value = ref(props.defaultValue + 1)
</script>
